export interface WebAppConfig {
  authDisabled: boolean;
  keycloakUrl: string;
  keycloakRealm: string;
  keycloakClientId: string;
  keycloakIdpHint: string;
}

export const DEFAULT_WEB_CONFIG: WebAppConfig = {
  authDisabled: false,
  keycloakUrl: 'http://localhost:8081',
  keycloakRealm: 'orqforge',
  keycloakClientId: 'orqforge-web',
  keycloakIdpHint: '',
};

export function parseWebAppConfig(raw: unknown): WebAppConfig {
  const o = raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {};
  const str = (value: unknown, fallback: string) =>
    typeof value === 'string' && value.trim() ? value.trim() : fallback;
  return {
    authDisabled: o.authDisabled === true || o.authDisabled === 'true',
    keycloakUrl:
      typeof o.keycloakUrl === 'string' ? o.keycloakUrl.trim() : DEFAULT_WEB_CONFIG.keycloakUrl,
    keycloakRealm: str(o.keycloakRealm, DEFAULT_WEB_CONFIG.keycloakRealm),
    keycloakClientId: str(o.keycloakClientId, DEFAULT_WEB_CONFIG.keycloakClientId),
    keycloakIdpHint:
      typeof o.keycloakIdpHint === 'string' ? o.keycloakIdpHint.trim() : DEFAULT_WEB_CONFIG.keycloakIdpHint,
  };
}

export function shouldUseKeycloak(config: WebAppConfig, hostname: string): boolean {
  if (config.authDisabled) return false;
  if (!config.keycloakUrl) return false;
  try {
    const host = new URL(config.keycloakUrl).hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return hostname === 'localhost' || hostname === '127.0.0.1';
    }
  } catch {
    return false;
  }
  return true;
}

export async function loadWebAppConfig(fetcher: typeof fetch = fetch): Promise<WebAppConfig> {
  try {
    const res = await fetcher('/config.json', { cache: 'no-store' });
    if (!res.ok) return DEFAULT_WEB_CONFIG;
    return parseWebAppConfig(await res.json());
  } catch {
    return DEFAULT_WEB_CONFIG;
  }
}
